import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Examen } from '../model/examen.model';
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExamenService {
  private apiUrl =  `${environment.apiUrl}/api/examenes`; 
  //private apiUrl = 'http://localhost:3000/api/examenes';

  constructor(private http: HttpClient) {}

  // Manejo centralizado de errores
  private manejarError(error: HttpErrorResponse): Observable<never> {
    let mensaje = 'Ocurrió un error inesperado';
    if (error.error?.message) {
      mensaje = error.error.message;
    }
    console.error('❌ Error en la petición HTTP:', error);
    Swal.fire({ icon: 'error', title: 'Error en la solicitud', text: mensaje });
    return throwError(() => new Error(mensaje));
  }

  // Obtener todos los exámenes
  getExamenes(): Observable<{ examenes: Examen[], estadisticas: any }> {
    return this.http.get<{ examenes: Examen[], estadisticas: any }>(this.apiUrl, {
      withCredentials: true
    }).pipe(catchError(this.manejarError));
  }

  // Obtener un examen por ID
  getExamenById(id: number): Observable<Examen> {
    return this.http.get<Examen>(`${this.apiUrl}/${id}`, {
      withCredentials: true
    }).pipe(catchError(this.manejarError));
  }

  // Crear un nuevo examen
  createExamen(data: Partial<Examen>): Observable<Examen> {
    return this.http.post<Examen>(this.apiUrl, data, {
      withCredentials: true
    }).pipe(catchError(this.manejarError));
  }

  // Actualizar un examen existente
  updateExamen(id: number, data: Partial<Examen>): Observable<Examen> {
    return this.http.put<Examen>(`${this.apiUrl}/${id}`, data, {
      withCredentials: true
    }).pipe(catchError(this.manejarError));
  }

  // Eliminar un examen por su ID
  deleteExamen(id: number): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.apiUrl}/${id}`, {
      withCredentials: true
    }).pipe(catchError(this.manejarError));
  }
}
